/**
 * Created by andrey on 24.05.17.
 */

cleverapps.override(cleverapps.Tool.game, {
    win_tournament: function () {
        const game = Game.currentGame;
        if (!cleverapps.Scenes.GetSceneComponent(GameSceneComponent) || !game) {
            return;
        }

        setTimeout(() => {
            game.board.words.forEach((word) => {
                game.board.foundWordsSet[word] = 1;
            });

            game.counter.trigger();
        }, 50);
    },

    win_2: function () {
        cleverapps.Tool.game.win_tournament(2);
    },

    win_3: function () {
        cleverapps.Tool.game.win_tournament(3);
    },

    win_4: function () {
        cleverapps.Tool.game.win_tournament(4);
    },

    addCoin: function () {
        if (["scramble"].indexOf(cleverapps.config.name) !== -1) {
            Game.currentGame.keypad.addRandomBonus();
        } else {
            alert("Scramble only");
        }
    },

    openWord: function (words) {
        if (Game.currentGame.counter.isActive()) {
            return;
        }

        words = words || Game.currentGame.board.words.filter((word) => !Game.currentGame.board.foundWordsSet[word]);

        for (let i = 0; i < words.length; i++) {
            const indexes = Game.currentGame.keypad.findWordIndexes(words[i]);

            if (indexes) {
                indexes.forEach((index) => {
                    Game.currentGame.current.push(index, true);
                });
                Game.currentGame.keypad.trigger("attempt", indexes);

                return;
            }
        }
    },

    listWords: function () {
        alert(Game.currentGame.level.content.words.join(" "));
    },

    openExtra: function () {
        const words = Object.keys(Game.currentGame.extra.wordsSet).filter((word) => !Game.currentGame.extra.foundWordsSet[word] && Game.currentGame.levelContent.words.indexOf(word) === -1);

        cleverapps.Tool.game.openWord(words);
    },

    listExtra: function () {
        let extraWords = [];
        if (cleverapps.config.name === "scramble") {
            const keypad = Game.currentGame.keypad;
            const words = Object.keys(Game.currentGame.extra.wordsSet);
            for (let i = 0; i < words.length && extraWords.length < 30; i++) {
                const indexes = keypad.findWordIndexes(words[i]);
                if (indexes && keypad.words.indexOf(words[i]) === -1) {
                    extraWords.push(words[i]);
                }
            }
        } else {
            extraWords = Game.currentGame.board.levelContent.extra;
        }

        alert(extraWords.join(" "));
    },

    addCookie: function () {
        levels.cookieJar.incCounter();
    },

    almostFillCookie: function () {
        levels.cookieJar.almostFill();
    }
});

delete cleverapps.Tool.UI.windows.movesFromFriend;